import React from "react";

import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
} from "@react-pdf/renderer";


const styles = StyleSheet.create({

page:{
    padding:35,
    backgroundColor:"#f2f2f2",
    fontSize:10,
},


bankHeader:{
    backgroundColor:"#ffb2b6",
    color:"#000000",
    padding:15,
    textAlign:"center",
    marginBottom:15,
},


schoolName:{
    fontSize:18,
    fontWeight:"bold",
},


subtitle:{
    marginTop:5,
    fontSize:11,
},



slipCard:{
    backgroundColor:"#ffffff",
    border:"1 solid #cccccc",
    padding:15,
    marginBottom:20,
},



sectionTitle:{
    backgroundColor:"#1b1b1b",
    color:"#ffffff",
    padding:6,
    fontSize:11,
    fontWeight:"bold",
    marginBottom:8,
},



infoBox:{
    backgroundColor:"#eeeeee",
    padding:10,
    marginBottom:10,
},



row:{
    flexDirection:"row",
    justifyContent:"space-between",
    marginBottom:6,
},



label:{
    color:"#333333",
},


value:{
    fontWeight:"bold",
},



tableHeader:{
    flexDirection:"row",
    backgroundColor:"#797676",
    color:"#000000",
    padding:7,
},


tableRow:{
    flexDirection:"row",
    padding:7,
    borderBottom:"1 solid #dddddd",
},



description:{
    width:"65%",
},


amount:{
    width:"35%",
    textAlign:"right",
},



totalBox:{
    marginTop:12,
    backgroundColor:"#a1a0a0",
    color:"#000000",
    padding:12,
},



signatureArea:{
    marginTop:30,
    flexDirection:"row",
    justifyContent:"space-between",
},



signature:{
    width:"40%",
    textAlign:"center",
},



line:{
    marginTop:30,
    borderTop:"1 solid #000",
},



footer:{
    textAlign:"center",
    marginTop:15,
    color:"#555555",
},




/* SIGNING SHEET */


sheetTitle:{
    textAlign:"center",
    fontSize:14,
    fontWeight:"bold",
    marginBottom:15,
},


sheetHeader:{
    flexDirection:"row",
    backgroundColor:"#000000",
    color:"#ffffff",
    padding:8,
},


sheetRow:{
    flexDirection:"row",
    backgroundColor:"#fff",
    padding:8,
    borderBottom:"1 solid #ddd",
},


nameCol:{
    width:"30%",
},


col:{
    width:"14%",
    textAlign:"center",
},


signatureCol:{
    width:"16%",
}


});





const money=(value)=>{

return `$${Number(value || 0).toFixed(2)}`;

};





function PayrollSlipGenerationPDF({
 payrolls=[],
 month,
 academicYear
}){


return (

<Document>


<Page size="A4" style={styles.page}>


<View style={styles.bankHeader}>

<Text style={styles.schoolName}>
Salvation In Christ School System
</Text>

<Text style={styles.subtitle}>
Official Monthly Payroll Statement
</Text>


</View>




{
payrolls.map((payroll,index)=>{


const name =
payroll.teacher?.full_name ||
payroll.support_staff_name ||
"-";



return (

<View 
key={payroll.id}
style={styles.slipCard}
>



<Text style={styles.sectionTitle}>
PAYSLIP #{index+1}
</Text>



<View style={styles.infoBox}>


<View style={styles.row}>
<Text>
Employee Name
</Text>

<Text style={styles.value}>
{name}
</Text>

</View>



<View style={styles.row}>

<Text>
Payroll Period
</Text>

<Text style={styles.value}>
{month} {academicYear}
</Text>

</View>


</View>





<Text style={styles.sectionTitle}>
Salary Breakdown
</Text>



<View style={styles.tableHeader}>

<Text style={styles.description}>
Description
</Text>

<Text style={styles.amount}>
Amount
</Text>

</View>




{[
["Basic Salary", payroll.basic_salary],
["Bonus / Compensation", payroll.night_school_commission],
["Salary Advance", -payroll.salary_advance],
["Income Tax", -payroll.income_tax],
["Social Security", -payroll.social_security_tax],
["Total Deduction", payroll.total_deductions],

].map((item,i)=>(

<View 
key={i}
style={styles.tableRow}
>

<Text style={styles.description}>
{item[0]}
</Text>

<Text style={styles.amount}>
{money(item[1])}
</Text>


</View>


))}




<View style={styles.totalBox}>


<View style={styles.row}>

<Text>
NET SALARY PAID
</Text>


<Text style={{fontSize:14,fontWeight:"bold"}}>
{money(payroll.total_paid)}
</Text>


</View>


</View>





<View style={styles.signatureArea}>


<View style={styles.signature}>

<Text>
Employee Signature
</Text>

<View style={styles.line}/>

</View>




<View style={styles.signature}>

<Text>
Authorized Signature
</Text>

<View style={styles.line}/>

</View>



</View>





<Text style={styles.footer}>
This document confirms salary payment received.
</Text>




</View>


)


})


}



</Page>









{/* SIGNING SHEET */}


<Page 
size="A4"
orientation="landscape"
style={styles.page}
>


<Text style={styles.sheetTitle}>
Salvation In Christ School System
Monthly Salary Signing Sheet
{` - ${month} ${academicYear}`}
</Text>




<View style={styles.sheetHeader}>


<Text style={styles.nameCol}>
Staff Name
</Text>

<Text style={styles.col}>
Salary
</Text>

<Text style={styles.col}>
Advance
</Text>

<Text style={styles.col}>
Tax
</Text>

<Text style={styles.col}>
Social
</Text>

<Text style={styles.col}>
Total
</Text>

<Text style={styles.signatureCol}>
Signature
</Text>



</View>





{
payrolls.map((p)=>(


<View 
key={p.id}
style={styles.sheetRow}
>


<Text style={styles.nameCol}>
{
p.teacher?.full_name ||
p.support_staff_name
}
</Text>


<Text style={styles.col}>
{money(p.basic_salary)}
</Text>


<Text style={styles.col}>
{money(p.salary_advance)}
</Text>


<Text style={styles.col}>
{money(p.income_tax)}
</Text>


<Text style={styles.col}>
{money(p.social_security_tax)}
</Text>


<Text style={styles.col}>
{money(p.total_paid)}
</Text>


<View style={styles.signatureCol}>
<Text>
________________
</Text>
</View>


</View>


))


}



</Page>



</Document>


);


}


export default PayrollSlipGenerationPDF;

